export class LayoutColumn {
    public autoSizeWidth: boolean;
    public displayName: string;
    public extractTarget: boolean;
    public justification: string;
    public list: string;
    public maxLen: string;
    public name: string;
    public validation: string;
    public width: number;
    public wordWrap: boolean;
    public isReadOnly: boolean;
    public sortOrder: number;
}

export class Layout {
    public type: number;
    public columns: Array<LayoutColumn> = [];

    public update(newLayout: Layout) {
        if (this.type != newLayout.type) this.type = newLayout.type;
        for (let i = 0; i < newLayout.columns.length; i++) {
            if (i >= this.columns.length) {
                // Need to add column
                this.columns.push(new LayoutColumn());
            }
            let col = this.columns[i];
            let newCol = newLayout.columns[i];
            if (col.autoSizeWidth != newCol.autoSizeWidth) col.autoSizeWidth = newCol.autoSizeWidth;
            if (col.displayName != newCol.displayName) col.displayName = newCol.displayName;
            if (col.extractTarget != newCol.extractTarget) col.extractTarget = newCol.extractTarget;
            if (col.justification != newCol.justification) col.justification = newCol.justification;
            if (col.list != newCol.list) col.list = newCol.list;
            if (col.maxLen != newCol.maxLen) col.maxLen = newCol.maxLen;
            if (col.name != newCol.name) col.name = newCol.name;
            if (col.validation != newCol.validation) col.validation = newCol.validation;
            if (col.width != newCol.width) col.width = newCol.width;
            if (col.wordWrap != newCol.wordWrap) col.wordWrap = newCol.wordWrap;
            if (col.isReadOnly != newCol.isReadOnly) col.isReadOnly = newCol.isReadOnly;
            if (col.sortOrder != newCol.sortOrder) col.sortOrder = newCol.sortOrder;
        }
        this.columns.splice(newLayout.columns.length);
    }
}